var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.75477 2C10.8541 2 13.3664 4.51231 13.3664 7.61167C13.3664 10.7111 10.8541 13.224 7.75477 13.224C4.65538 13.224 2.14307 10.7111 2.14307 7.61167C2.14307 4.51231 4.65538 2 7.75477 2Z","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.5742 11.7266L13.8576 14.004","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
